module.exports = __webpack_public_path__ + "static/media/Untitled-6@3x.214703a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/02/02/assets/Untitled-6@3x.svg
// module id = 439
// module chunks = 0